import React, { useState, useEffect, useContext } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { listInvoice, deleteInvoice } from 'services/billingServices';
import { format } from 'date-fns';
import _ from 'lodash';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { RecordPayment } from './RecordPayment';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { SendNotificationMail } from './SendNotificationMail';
import { Reminders } from './Reminders';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { formatNumbersToCurrencyString, openLinkInBlank, paginationDropdownOptions } from 'utils/utils';
import CreateInvoice from './CreateInvoice/CreateInvoice';
import { UserDetailsContext } from 'context/userDetailsContext';
import { handlePageNumberInPagination } from 'common/pagination';
import { getLocalStorageParseItem, removeLocalStorageItem, setLocalStorageItem } from 'utils/localStorageUtils';
import { calculateDaysPastDue, handleDateTimeOffset } from 'utils/utility_functions/timezone';
import moment from 'moment';
import { tableCell } from 'modules/reports/components/TableCell/TableCell';
import constants from 'constants/index';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { useFirmUserList } from 'hooks/useFirmUserList';
import { generateFullName } from 'utils/generateFullNameUtils';
import GlobalTooltip from 'components/GlobalTooltip';
import IntuitPaymentModal from 'modules/client/intuit/IntuitPaymentModal';
import { LoaderComponent } from 'shared/LoaderComponent';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import useFilterBreakpoint from 'hooks/useFilterBreakpoint';

export const Invoices = (props) => {
  const {
    isFromCaseSpecificModule,
    getCaseDetails,
    getTimeEntrySummarty,
    isFromGlobalBilling,
    handleInvoiceTableRedirection,
    onTrustHorizonRefresh,
  } = props || {};
  const [searchKey, setSearchKey] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [showCreateInvoice, setShowCreateInvoice] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [viewInvoice, setViewInvoice] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { addToast } = useToast();
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [confirmSendMail, setConfirmSendMail] = useState(false);
  const location = useLocation();
  const userContext = useContext(UserDetailsContext);
  const [showReminder, setShowReminder] = useState(false);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [pageLimit, setPageLimit] = useState(getPageLimit() ?? 10);
  const [isForward, setIsForward] = useState(true);
  const next_Token = invoiceList.next_token;
  const transition_Token = invoiceList.transition_token;
  const practiceData = useSelector((state) => state.practiceArea.practiceAreaList['practice-area']);
  const [practiceAreaOptions, setPracticeAreaOptions] = useState([]);
  const [selectedLeadAttorneyList, setSelectedLeadAttorneyList] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(null);
  const { userList, isFirmUserLoading } = useFirmUserList(false, false, true);

  function getPageLimit() {
    if (props.isLeadSpecific && userContext) {
      return userContext?.firmDetails?.pagination_preference?.leads?.billings?.invoices;
    } else if (isFromCaseSpecificModule && userContext) {
      return userContext?.firmDetails?.pagination_preference?.case?.billings?.invoices;
    } else if (userContext) {
      return userContext?.firmDetails?.pagination_preference?.billings?.invoices;
    }
  }

  const loadInvoices = (filters, pageLimit = getPageLimit() ?? 10, pagination_token = '', pagination_direction = 'forward') => {
    if (props.caseView) {
      filters.case_id = props?.caseDetails?.case_id;
    }
    listInvoice(filters, pageLimit, pagination_token, pagination_direction)
      .then((response) => {
        if (response?.data) {
          setInvoiceList(response.data);
        }
      })
      .catch((err) => {});
  };

  function getFilePathForPagination() {
    if (props.isLeadSpecific && userContext) {
      return { module: 'leads', subModule: 'billings', listName: 'invoices' };
    } else if (isFromCaseSpecificModule && userContext) {
      return { module: 'case', subModule: 'billings', listName: 'invoices' };
    } else {
      return { module: 'billings', subModule: '', listName: 'invoices' };
    }
  }

  const onChangePractice = (e) => {
    setSelectedPractice([...e.value]);
    let filters = {
      ...pickExtractedDate(dateFilter),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: [...e.value],
    };
    loadInvoices(filters);
  };

  const onChangeSearch = (e) => {
    setSearchKey(e.target.value);
    if (!e.target.value) {
      let filters = {
        ...pickExtractedDate(dateFilter),
        invoice_status: '',
        search_key: '',
        case_id: '',
        practice_area: selectedPractice,
      };
      loadInvoices(filters);
    }
  };
  const onSearchKeyDown = (e) => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      let filters = {
        ...pickExtractedDate(dateFilter),
        invoice_status: '',
        search_key: searchKey,
        case_id: '',
        practice_area: selectedPractice,
      };
      loadInvoices(filters);
    }
  };

  const pickExtractedDate = (dateArray) => {
    return {
      invoice_date_lower: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), userContext?.userDetails.timezone)
        : '',
      invoice_date_upper: dateArray?.[0]
        ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), userContext?.userDetails.timezone)
        : '',
    };
  };

  const onChangeCalendar = (e) => {
    setDateFilter(e.value);

    let filters = {
      ...pickExtractedDate(e.value),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: selectedPractice,
    };
    loadInvoices(filters);
  };

  const onChangeLeadAttorney = (e) => {
    const list = e.value !== null ? [...e.value] : null;
    setSelectedLeadAttorneyList(list);

    let filters = {
      ...pickExtractedDate(dateFilter),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: selectedPractice,
      lead_attorney_list: list,
    };
    loadInvoices(filters);
  };

  const caseBody = (rowData) => {
    const { is_lead } = rowData;
    const mainModuleName = is_lead ? '/leads' : '/cases';
    let route = rowData?.invoice?.case_id ? `${mainModuleName}/${rowData?.invoice?.case_id}` : mainModuleName;

    return (
      <React.Fragment>
        <span className="p-column-title text-break">Case</span>
        <Link
          to={route}
          className="redirection-link-no-text-transform"
          title={rowData?.invoice?.case_name ? rowData.invoice?.case_name : undefined}
        >
          {rowData?.invoice?.case_name ? rowData.invoice?.case_name : '-'}
        </Link>
      </React.Fragment>
    );
  };

  const onSuccess = () => {
    setShowCreateInvoice(false);
    setShowRecordModal(false);
    if (props?.setShowPaymentPlanCreateInvoice && props?.setSelectedPaymentPlan) {
      props?.setShowPaymentPlanCreateInvoice(false);
      props?.setSelectedPaymentPlan({});
    }
    let filters = {
      ...pickExtractedDate(dateFilter),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: selectedPractice,
    };
    loadInvoices(filters);
    typeof getTimeEntrySummarty === 'function' && getTimeEntrySummarty();
    if (
      (props?.caseDetails && !props?.caseDetails?.default_trust_account?.[0]?.account_id) ||
      !props?.caseDetails?.default_operating_account?.[0]?.account_id
    ) {
      typeof getCaseDetails === 'function' && getCaseDetails();
    }
    if (isFromCaseSpecificModule) {
      setTimeout(() => {
        onTrustHorizonRefresh();
      }, 3000);
    }
  };
  const paginatorTemplate = {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: (options) => {
      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
            Item Per Page
          </span>
          <Dropdown value={options.value} options={paginationDropdownOptions} onChange={onPageChange} />
        </React.Fragment>
      );
    },
    NextPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onNextPageClick}
          disabled={next_Token === null && isForward}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
    PrevPageLink: ({ iconClassName }) => {
      return (
        <Button
          onClick={onPrevPageClick}
          disabled={transition_Token === null || (transition_Token && next_Token === null && !isForward)}
          className={'p-paginator-next p-paginator-element p-link'}
          icon={iconClassName}
        />
      );
    },
  };
  let filters = {
    ...pickExtractedDate(dateFilter),
    invoice_status: '',
    search_key: searchKey,
    case_id: '',
    practice_area: selectedPractice,
  };

  const onNextPageClick = () => {
    loadInvoices(filters, pageLimit, !isForward ? transition_Token : next_Token, 'forward');
    setIsForward(true);
  };
  const onPrevPageClick = () => {
    loadInvoices(filters, pageLimit, isForward ? transition_Token : next_Token, 'reverse');
    setIsForward(false);
    //setPreviousToken(transition_Token);
  };
  const onPageChange = (event) => {
    setPageLimit(event.value);
    let path = getFilePathForPagination();
    handlePageNumberInPagination(userContext, path?.module, path?.subModule, path?.listName, event.value);
    loadInvoices(filters, event.value, '', 'forward');
  };

  const refreshCase = () => {
    setSearchKey('');
    setDateFilter('');
    setSelectedInvoice('');
    setSelectedPractice();
    let filters = {
      invoice_date_upper: '',
      invoice_date_lower: '',
      invoice_status: '',
      search_key: '',
      case_id: '',
      practice_area: '',
    };
    loadInvoices(filters);
  };

  const viewBody = (rowData) => {
    return (
      <>
        <span className="p-column-title text-break">Viewed</span>
        <span title={Date.parse(rowData?.viewed_status) ? format(new Date(rowData?.viewed_status), 'MM/dd/yyyy') : rowData?.viewed_status}>
          {Date.parse(rowData?.viewed_status) ? format(new Date(rowData?.viewed_status), 'MM/dd/yyyy') : rowData?.viewed_status}
        </span>
      </>
    );
  };

  const actionBody = (rowData) => {
    let due_amount = rowData?.due_amount;
    due_amount = due_amount ? parseInt(due_amount) : 0;

    const onClickViewInvoiceDetailsLink = (e) => {
      e.preventDefault();

      const isLead = rowData?.invoice?.is_lead;
      const caseId = rowData?.invoice?.case_id;

      const mainModuleName = isLead ? '/leads' : '/cases';
      const route = caseId ? `${mainModuleName}/${caseId}/billing` : mainModuleName;
      const stateToPass = { invoiceDetails: rowData };

      setLocalStorageItem('viewInvoice', true);

      if (!openLinkInBlank(route, stateToPass)) {
        setSelectedInvoice({ ...rowData });
        setViewInvoice(true);
        setShowCreateInvoice(true);
      }
    };

    return (
      <React.Fragment>
        <span className="p-column-title text-break">Action</span>
        <span role="button" onClick={(e) => onClickViewInvoiceDetailsLink(e)} className="text-primary-dark">
          View
        </span>
        {due_amount > 0 && (
          <span
            role="button"
            onClick={(e) => {
              setSelectedInvoice({ ...rowData });
              setConfirmSendMail(true);
            }}
          >
            <GlobalTooltip tooltip="Payment Request" className={'ms-2'}>
              <i className="icon-send-form" />
            </GlobalTooltip>
          </span>
        )}
        {due_amount > 0 && rowData?.invoice_status !== 'FORWARDED' && (
          <span role="button">
            <GlobalTooltip tooltip="Record Payment" className={'ms-2'}>
              <i
                className="icon-radio"
                onClick={(e) => {
                  setSelectedInvoice({ ...rowData });
                  setShowRecordModal(true);
                }}
              />
            </GlobalTooltip>
          </span>
        )}
        {due_amount > 0 && userContext?.userDetails?.is_quickbook_connected && rowData?.invoice_status !== 'FORWARDED' && (
          <span role="button">
            <GlobalTooltip tooltip="Accept Payment" className={'ms-2'}>
              <i className="bi bi-credit-card-2-back" style={{ color: '#7f8f9f' }} onClick={() => setShowPaymentModal(rowData)} />
            </GlobalTooltip>
          </span>
        )}
        <span
          role="button"
          onClick={(e) => {
            setSelectedInvoice({ ...rowData });
            setShowReminder(true);
          }}
        >
          <GlobalTooltip tooltip="Reminder" className="ms-2">
            <i className="icon-notification" />
          </GlobalTooltip>
        </span>
        {rowData?.invoice_status !== 'PARTIAL' && rowData?.invoice_status !== 'PAID' && (
          <span role="button">
            <GlobalTooltip tooltip="Delete" className="ms-2">
              <i
                className="icon-delete cursor-pointer"
                onClick={() => {
                  setSelectedInvoice({ ...rowData });
                  setConfirmDelete(true);
                }}
              />
            </GlobalTooltip>
          </span>
        )}
      </React.Fragment>
    );
  };
  const onCreateSuccess = () => {
    setShowReminder(false);
    let filters = {
      ...pickExtractedDate(dateFilter),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: selectedPractice,
    };
    loadInvoices(filters);
    typeof getTimeEntrySummarty === 'function' && getTimeEntrySummarty();
  };

  const onDeleteInvoice = () => {
    let sk = selectedInvoice?.sk;
    deleteInvoice(sk, props?.isLeadSpecific ? props?.isLeadSpecific : selectedInvoice?.is_lead)
      .then((response) => {
        let filters = {
          ...pickExtractedDate(dateFilter),
          invoice_status: '',
          search_key: searchKey,
          case_id: '',
          practice_area: selectedPractice,
        };
        loadInvoices(filters);
        typeof getTimeEntrySummarty === 'function' && getTimeEntrySummarty();
        if (isFromCaseSpecificModule) {
          onTrustHorizonRefresh();
        }
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.DELETE_INVOICE_SUCCESS);
      })
      .catch((err) => {
        let msg = toastConstant.message.DELETE_INVOICE_FAILED;
        if (err && err?.response?.data?.message) {
          msg = err.response.data.message;
        }
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, msg);
      });
  };

  const dueDateBody = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Sent Date</span>
        <span
          className="text-break"
          title={handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.invoice_date, constants.month_date_year_format)}
        >
          {handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.invoice_date, constants.month_date_year_format)}
        </span>
      </React.Fragment>
    );
  };

  const nextDueDateBody = (rowData) => {
    const shouldShow = rowData?.invoice_status === 'PAID' || rowData?.invoice_status === 'FORWARDED';
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Next Due Date</span>
        <span
          className="text-break"
          title={
            shouldShow
              ? undefined
              : handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.due_date, constants.month_date_year_format)
          }
        >
          {shouldShow ? '-' : handleDateTimeOffset(userContext?.userDetails?.timezone, rowData?.due_date, constants.month_date_year_format)}
        </span>
      </React.Fragment>
    );
  };

  const dueTodayBody = (rowData) => {
    if (!rowData?.is_payment_plan) {
      return (
        <React.Fragment>
          <span className="p-column-title text-break">Due Today</span>
          <span className="text-break" title="-">
            -
          </span>
        </React.Fragment>
      );
    }

    const hasForwardedRef = rowData?.invoice_unpaid_ref_number || rowData?.invoice_status === 'FORWARDED';
    const hasPlanDueAmount = rowData?.plan_due_amount !== undefined && rowData?.plan_due_amount !== null;
    const displayAmount = hasForwardedRef
      ? formatNumbersToCurrencyString(0.0)
      : hasPlanDueAmount
      ? formatNumbersToCurrencyString(rowData?.plan_due_amount)
      : formatNumbersToCurrencyString(rowData?.due_amount);

    return (
      <React.Fragment>
        <span className="p-column-title text-break">Due Today</span>
        <span className="text-break" title={displayAmount}>
          {displayAmount}
        </span>
      </React.Fragment>
    );
  };

  const daysPastDueBody = (rowData) => {
    const dueDays =
      rowData?.invoice_status === 'PAID' || rowData?.invoice_status === 'FORWARDED'
        ? '-'
        : rowData?.is_payment_plan && rowData?.last_unpaid_due_date
        ? calculateDaysPastDue(rowData?.last_unpaid_due_date, userContext?.userDetails?.timezone)
        : calculateDaysPastDue(rowData?.due_date, userContext?.userDetails?.timezone);
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Days Past Due</span>
        <span className="text-break" title={dueDays ? dueDays : undefined}>
          {dueDays}
        </span>
      </React.Fragment>
    );
  };

  const assignToItemTemplate = (option) => {
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {generateFullName(option)}
      </>
    );
  };

  useEffect(() => {
    let filters = {
      ...pickExtractedDate(dateFilter),
      invoice_status: '',
      search_key: searchKey,
      case_id: '',
      practice_area: selectedPractice,
    };
    loadInvoices(filters);
  }, []);

  useEffect(() => {
    if (practiceData && practiceData.length) {
      let practice_options = practiceData.map((val) => {
        return {
          label: val.practice_area_name,
          value: val.practice_area_id,
        };
      });
      setPracticeAreaOptions(practice_options);
    } else {
      setPracticeAreaOptions([]);
    }
  }, [practiceData]);

  useEffect(() => {
    if (localStorage.getItem('redirectToInvoice')) {
      setShowCreateInvoice(true);
      localStorage.removeItem('redirectToInvoice');
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const invoiceSk = queryParams.get('invoice_sk');

    if (invoiceSk && !selectedInvoice) {
      const decodedInvoiceSk = decodeURIComponent(invoiceSk);
      const invoiceData = { sk: decodedInvoiceSk };
      setSelectedInvoice(invoiceData);
      setViewInvoice(true);
      setShowCreateInvoice(true);
    } else if (!invoiceSk && !selectedInvoice) {
      let invoiceDetails = location?.state?.invoiceDetails || getLocalStorageParseItem('stateData')?.invoiceDetails;

      if (invoiceDetails && !selectedInvoice) {
        setSelectedInvoice(invoiceDetails);
        setViewInvoice(true);
        setShowCreateInvoice(true);
        removeLocalStorageItem('stateData');
      }
    }
  }, [location]);

  useEffect(() => {
    if (showCreateInvoice) {
      document.body.style.overflow = 'hidden';
    }
    // Clean up the effect when the component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showCreateInvoice]); // to remove the dropdown scroll issue in dialog dropdown
  const { showFilters, setShowFilters } = useFilterBreakpoint();

  return (
    <div>
      {showRecordModal && (
        <RecordPayment
          show={showRecordModal}
          onHide={() => {
            setShowRecordModal(false);
          }}
          selectedInvoice={selectedInvoice}
          onSuccess={onSuccess}
          caseDetails={props?.caseDetails}
        />
      )}

      {showCreateInvoice && (
        <CreateInvoice
          show
          onHide={() => {
            setShowCreateInvoice(false);
            const queryParams = new URLSearchParams(location.search);
            const hadInvoiceSk = queryParams.has('invoice_sk');

            if (hadInvoiceSk) {
              const cleanUrl = window.location.href.split('?')[0];
              window.history.replaceState({}, '', cleanUrl);
            }

            if (props?.setShowPaymentPlanCreateInvoice && props?.setSelectedPaymentPlan) {
              props?.setShowPaymentPlanCreateInvoice(false);
              props?.setSelectedPaymentPlan({});
            }
          }}
          onSuccess={onSuccess}
          selectedInvoice={selectedInvoice}
          viewInvoice={viewInvoice}
          caseView={props.caseView}
          isLeadSpecific={props.isLeadSpecific}
          caseDetails={props.caseDetails}
          setShowRecordModal={setShowRecordModal}
          loadInvoices={loadInvoices}
          filters={filters}
          getPageLimit={getPageLimit}
          updateCaseDetails={props?.updateCaseDetails}
          getCaseDetails={getCaseDetails}
        />
      )}
      {confirmDelete && (
        <ConfirmDialog
          className="common-popup-style confirm-delete-popup"
          visible={confirmDelete}
          rejectClassName="p-button-secondary outline"
          onHide={() => setConfirmDelete(false)}
          header="Confirm Delete"
          message={' Do you want to delete this invoice?'}
          icon="pi pi-exclamation-triangle"
          accept={() => {
            onDeleteInvoice();
          }}
          reject={() => setConfirmDelete(false)}
        />
      )}
      {confirmSendMail && (
        <SendNotificationMail
          show={confirmSendMail}
          onHide={() => {
            setConfirmSendMail(false);
          }}
          selectedRequest={selectedInvoice}
          invoiceView={true}
          isLeadSpecific={props.isLeadSpecific}
        />
      )}

      {showReminder && (
        <Reminders
          show
          onHide={() => {
            setShowReminder(false);
          }}
          selectedRequest={{ ...selectedInvoice, ...(selectedInvoice?.invoice || {}) }}
          onSuccess={onCreateSuccess}
          isInvoice
          isLeadSpecific={props.isLeadSpecific}
        />
      )}
      {Boolean(showPaymentModal) && (
        <IntuitPaymentModal
          isFromFirm
          handleClose={() => setShowPaymentModal(null)}
          paymentDetails={showPaymentModal}
          loadData={onCreateSuccess}
        />
      )}

      <div className="row">
        <div className="col-12">
          <div className="d-flex align-items-center mb-3">
            <Button
              label="Create Invoice"
              icon="pi pi-plus"
              className="p-button p-button-primary ms-auto"
              onClick={() => {
                setSelectedInvoice();
                setViewInvoice(false);
                setShowCreateInvoice(true);
              }}
            />
          </div>
        </div>
      </div>
      <div className="">
        <div className="d-flex flex-wrap align-items-center filter-wrap gap-2 mb-3 p-2 p-lg-0 w-100 align-items-center justify-content-between">
          <div className="p-2 filter-wraper">
            <span className="p-input-icon-right input-shadow w-100">
              <i className="icon-search F-size16"></i>
              <TextSnippetWrapper
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  onChangeSearch(e);
                }}
                value={searchKey}
                onKeyDown={onSearchKeyDown}
                className="p-inputtext p-component input-search"
                autoComplete="off"
              />
            </span>
          </div>
          <div className="d-block d-lg-none w-100">
            <Button
              className="p-button p-component btn p-button-secondary outline w-100 filter-toggle-btn"
              type="button"
              onClick={() => setShowFilters((v) => !v)}
              aria-expanded={showFilters}
              aria-controls="invoice-filter-section"
              label="Filters"
            >
              <span
                style={{
                  fontSize: 18,
                  transition: 'transform 0.2s',
                  display: 'inline-block',
                  transform: showFilters ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                <i className="fa fa-solid fa-angle-down"></i>
              </span>
            </Button>
          </div>
          <div
            className={`d-flex flex-wrap align-items-center gap-2 filter-toggle-section filter-section${showFilters ? ' show' : ''}`}
            id="invoice-filter-section"
            aria-hidden={!showFilters}
          >
            <label className="text-bold black-600 p-0 filter-label">Filter:</label>
            <div className="d-flex flex-column filter-wraper">
              <Calendar
                className="input-shadow filter-calender"
                id="icon"
                selectionMode="range"
                value={dateFilter}
                onChange={(e) => {
                  onChangeCalendar(e);
                }}
                showIcon
                placeholder="Date"
              />
            </div>
            {!isFromCaseSpecificModule && !props?.isLeadSpecific && (
              <div className="d-flex flex-column filter-wraper">
                <MultiSelect
                  value={selectedPractice}
                  options={practiceAreaOptions}
                  onChange={onChangePractice}
                  placeholder="Practice Area"
                  maxSelectedLabels={1}
                  display="chip"
                  filter
                  className="input-shadow w-100 F-size14 input-width"
                />
              </div>
            )}
            <div className="d-flex flex-column filter-wraper">
              <MultiSelect
                value={selectedLeadAttorneyList}
                options={userList}
                onChange={onChangeLeadAttorney}
                optionLabel={(v) => generateFullName(v)}
                optionValue="client_cognito_username"
                placeholder="Lead Attorney"
                maxSelectedLabels={1}
                display="chip"
                filter
                className="input-shadow w-100 F-size14 input-width"
                showClear
                itemTemplate={assignToItemTemplate}
                panelFooterTemplate={isFirmUserLoading ? LoaderComponent : null}
              />
            </div>

            <div className="d-flex flex-column ">
              <div className="pointer me-2">
                <GlobalTooltip tooltip="Reset Filter">
                  <i className="fas fa-sync-alt" onClick={refreshCase}></i>
                </GlobalTooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="datatable-responsive bg-white shadow-middle mb-3">
        <ResizableDataTable
          value={invoiceList?.invoices || []}
          className="p-datatable-responsive"
          paginator
          paginatorTemplate={paginatorTemplate}
          rows={pageLimit}
          storageKey="billing-invoices-list"
          columns={[
            { field: 'invoice_number', header: 'ID', body: tableCell, bodyClassName: 'ellipsis-text' },
            {
              field: 'case_description.case_name',
              header: 'Case',
              body: caseBody,
              bodyClassName: 'ellipsis-text',
              hidden: !isFromGlobalBilling,
            },
            { field: 'viewed_status', header: 'Viewed', body: viewBody, bodyClassName: 'ellipsis-text' },
            {
              field: 'total_flat_fee',
              header: 'Total Fee',
              body: (rowData) => {
                if (rowData?.total_amount)
                  return (
                    <>
                      <span className="p-column-title text-break">Total Fee</span>
                      <span className="text-break" title={formatNumbersToCurrencyString(rowData?.total_amount)}>
                        {formatNumbersToCurrencyString(rowData?.total_amount)}
                      </span>
                    </>
                  );
              },
              bodyClassName: 'ellipsis-text',
            },
            {
              field: 'invoice_status',
              header: 'Status',
              body: (rowData) => {
                if (rowData?.invoice_status)
                  return (
                    <>
                      <span className="p-column-title text-break">Status</span>
                      <span title={_.startCase(_.toLower(rowData?.invoice_status))}>{_.startCase(_.toLower(rowData?.invoice_status))}</span>
                    </>
                  );
              },
              bodyClassName: 'ellipsis-text',
            },
            {
              field: 'due_amount',
              header: 'Due',
              body: (rowData) => {
                return (
                  <>
                    <span className="p-column-title text-break">Due</span>
                    {rowData?.is_payment_plan &&
                      (rowData?.plan_due_amount || rowData?.due_amount) &&
                      rowData?.invoice_status !== 'FORWARDED' && (
                        <span className="text-nowrap" title={formatNumbersToCurrencyString(rowData?.due_amount)}>
                          {formatNumbersToCurrencyString(rowData?.due_amount)}
                        </span>
                      )}
                    {(!rowData?.is_payment_plan || rowData?.invoice_status === 'FORWARDED') && rowData?.due_amount && (
                      <span className="text-nowrap" title={formatNumbersToCurrencyString(rowData?.due_amount)}>
                        {formatNumbersToCurrencyString(rowData?.due_amount)}
                      </span>
                    )}
                    {rowData?.invoice_unpaid_ref_number && (
                      <span className="text-break ms-1" title={`Forwarded to ${rowData?.invoice_unpaid_ref_number}`}>
                        Forwarded to {rowData?.invoice_unpaid_ref_number}
                      </span>
                    )}
                  </>
                );
              },
              bodyClassName: 'ellipsis-text',
            },
            { field: 'plan_due_amount', header: 'Due Today', body: dueTodayBody, bodyClassName: 'ellipsis-text' },
            { field: 'next_due_date', header: 'Next Due Date', body: nextDueDateBody, bodyClassName: 'ellipsis-text' },
            { field: 'invoice_date', header: 'Sent Date', body: dueDateBody, bodyClassName: 'ellipsis-text' },
            { field: 'due_date', header: 'Days Past Due', body: daysPastDueBody, bodyClassName: 'ellipsis-text' },
            { field: 'action', header: '', body: actionBody, sortable: false, fixed: true, width: '180px', resizable: false },
          ]}
        />
      </div>
    </div>
  );
};
